/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeTalentPanelResponseDto } from '../models';
// @ts-ignore
import type { EmployeeTalentPanelsResponseDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { UpsertEmployeeTalentPanelRequestDto } from '../models';
/**
 * EmployeeTalentPanelApi - axios parameter creator
 * @export
 */
export const EmployeeTalentPanelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Kazdy zapis to nowy panel. Poprzednie zostaja i sa widoczne na liscie.
         * @summary Record another panel for the employee (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployeeTalentPanel: async (employeeId: string, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('addEmployeeTalentPanel', 'employeeId', employeeId)
            // verify required parameter 'upsertEmployeeTalentPanelRequestDto' is not null or undefined
            assertParamExists('addEmployeeTalentPanel', 'upsertEmployeeTalentPanelRequestDto', upsertEmployeeTalentPanelRequestDto)
            const localVarPath = `/api/v2/employees/{employeeId}/talent-panels`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEmployeeTalentPanelRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pracownik moze przejsc kilka paneli. Lista wraca posortowana malejaco po dacie panelu, stronicowana — front dociaga kolejne strony w miare przewijania. Identyfikator rozstrzyga remisy w sortowaniu, zeby kolejne strony nie gubily ani nie powtarzaly wpisow. 
         * @summary Panels the employee has been through, newest first (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {number} pageSize 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmployeeTalentPanels: async (employeeId: string, pageSize: number, page: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('readEmployeeTalentPanels', 'employeeId', employeeId)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('readEmployeeTalentPanels', 'pageSize', pageSize)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('readEmployeeTalentPanels', 'page', page)
            const localVarPath = `/api/v2/employees/{employeeId}/talent-panels`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Correct a recorded panel (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {number} panelId Identyfikator zapisanego panelu.
         * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeTalentPanel: async (employeeId: string, panelId: number, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('updateEmployeeTalentPanel', 'employeeId', employeeId)
            // verify required parameter 'panelId' is not null or undefined
            assertParamExists('updateEmployeeTalentPanel', 'panelId', panelId)
            // verify required parameter 'upsertEmployeeTalentPanelRequestDto' is not null or undefined
            assertParamExists('updateEmployeeTalentPanel', 'upsertEmployeeTalentPanelRequestDto', upsertEmployeeTalentPanelRequestDto)
            const localVarPath = `/api/v2/employees/{employeeId}/talent-panels/{panelId}`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"panelId"}}`, encodeURIComponent(String(panelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertEmployeeTalentPanelRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeTalentPanelApi - functional programming interface
 * @export
 */
export const EmployeeTalentPanelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeTalentPanelApiAxiosParamCreator(configuration)
    return {
        /**
         * Kazdy zapis to nowy panel. Poprzednie zostaja i sa widoczne na liscie.
         * @summary Record another panel for the employee (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEmployeeTalentPanel(employeeId: string, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTalentPanelResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEmployeeTalentPanel(employeeId, upsertEmployeeTalentPanelRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeTalentPanelApi.addEmployeeTalentPanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pracownik moze przejsc kilka paneli. Lista wraca posortowana malejaco po dacie panelu, stronicowana — front dociaga kolejne strony w miare przewijania. Identyfikator rozstrzyga remisy w sortowaniu, zeby kolejne strony nie gubily ani nie powtarzaly wpisow. 
         * @summary Panels the employee has been through, newest first (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {number} pageSize 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readEmployeeTalentPanels(employeeId: string, pageSize: number, page: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTalentPanelsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readEmployeeTalentPanels(employeeId, pageSize, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeTalentPanelApi.readEmployeeTalentPanels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Correct a recorded panel (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {number} panelId Identyfikator zapisanego panelu.
         * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEmployeeTalentPanel(employeeId: string, panelId: number, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeTalentPanelResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmployeeTalentPanel(employeeId, panelId, upsertEmployeeTalentPanelRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeTalentPanelApi.updateEmployeeTalentPanel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeTalentPanelApi - factory interface
 * @export
 */
export const EmployeeTalentPanelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeTalentPanelApiFp(configuration)
    return {
        /**
         * Kazdy zapis to nowy panel. Poprzednie zostaja i sa widoczne na liscie.
         * @summary Record another panel for the employee (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployeeTalentPanel(employeeId: string, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTalentPanelResponseDto> {
            return localVarFp.addEmployeeTalentPanel(employeeId, upsertEmployeeTalentPanelRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Pracownik moze przejsc kilka paneli. Lista wraca posortowana malejaco po dacie panelu, stronicowana — front dociaga kolejne strony w miare przewijania. Identyfikator rozstrzyga remisy w sortowaniu, zeby kolejne strony nie gubily ani nie powtarzaly wpisow. 
         * @summary Panels the employee has been through, newest first (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {number} pageSize 
         * @param {number} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readEmployeeTalentPanels(employeeId: string, pageSize: number, page: number, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTalentPanelsResponseDto> {
            return localVarFp.readEmployeeTalentPanels(employeeId, pageSize, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Correct a recorded panel (HRBP in subordinate area / ADMIN)
         * @param {string} employeeId 
         * @param {number} panelId Identyfikator zapisanego panelu.
         * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEmployeeTalentPanel(employeeId: string, panelId: number, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTalentPanelResponseDto> {
            return localVarFp.updateEmployeeTalentPanel(employeeId, panelId, upsertEmployeeTalentPanelRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeTalentPanelApi - interface
 * @export
 * @interface EmployeeTalentPanelApi
 */
export interface EmployeeTalentPanelApiInterface {
    /**
     * Kazdy zapis to nowy panel. Poprzednie zostaja i sa widoczne na liscie.
     * @summary Record another panel for the employee (HRBP in subordinate area / ADMIN)
     * @param {string} employeeId 
     * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeTalentPanelApiInterface
     */
    addEmployeeTalentPanel(employeeId: string, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTalentPanelResponseDto>;

    /**
     * Pracownik moze przejsc kilka paneli. Lista wraca posortowana malejaco po dacie panelu, stronicowana — front dociaga kolejne strony w miare przewijania. Identyfikator rozstrzyga remisy w sortowaniu, zeby kolejne strony nie gubily ani nie powtarzaly wpisow. 
     * @summary Panels the employee has been through, newest first (HRBP in subordinate area / ADMIN)
     * @param {string} employeeId 
     * @param {number} pageSize 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeTalentPanelApiInterface
     */
    readEmployeeTalentPanels(employeeId: string, pageSize: number, page: number, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTalentPanelsResponseDto>;

    /**
     * 
     * @summary Correct a recorded panel (HRBP in subordinate area / ADMIN)
     * @param {string} employeeId 
     * @param {number} panelId Identyfikator zapisanego panelu.
     * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeTalentPanelApiInterface
     */
    updateEmployeeTalentPanel(employeeId: string, panelId: number, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeTalentPanelResponseDto>;

}

/**
 * EmployeeTalentPanelApi - object-oriented interface
 * @export
 * @class EmployeeTalentPanelApi
 * @extends {BaseAPI}
 */
export class EmployeeTalentPanelApi extends BaseAPI implements EmployeeTalentPanelApiInterface {
    /**
     * Kazdy zapis to nowy panel. Poprzednie zostaja i sa widoczne na liscie.
     * @summary Record another panel for the employee (HRBP in subordinate area / ADMIN)
     * @param {string} employeeId 
     * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeTalentPanelApi
     */
    public addEmployeeTalentPanel(employeeId: string, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig) {
        return EmployeeTalentPanelApiFp(this.configuration).addEmployeeTalentPanel(employeeId, upsertEmployeeTalentPanelRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pracownik moze przejsc kilka paneli. Lista wraca posortowana malejaco po dacie panelu, stronicowana — front dociaga kolejne strony w miare przewijania. Identyfikator rozstrzyga remisy w sortowaniu, zeby kolejne strony nie gubily ani nie powtarzaly wpisow. 
     * @summary Panels the employee has been through, newest first (HRBP in subordinate area / ADMIN)
     * @param {string} employeeId 
     * @param {number} pageSize 
     * @param {number} page 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeTalentPanelApi
     */
    public readEmployeeTalentPanels(employeeId: string, pageSize: number, page: number, options?: RawAxiosRequestConfig) {
        return EmployeeTalentPanelApiFp(this.configuration).readEmployeeTalentPanels(employeeId, pageSize, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Correct a recorded panel (HRBP in subordinate area / ADMIN)
     * @param {string} employeeId 
     * @param {number} panelId Identyfikator zapisanego panelu.
     * @param {UpsertEmployeeTalentPanelRequestDto} upsertEmployeeTalentPanelRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeTalentPanelApi
     */
    public updateEmployeeTalentPanel(employeeId: string, panelId: number, upsertEmployeeTalentPanelRequestDto: UpsertEmployeeTalentPanelRequestDto, options?: RawAxiosRequestConfig) {
        return EmployeeTalentPanelApiFp(this.configuration).updateEmployeeTalentPanel(employeeId, panelId, upsertEmployeeTalentPanelRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

